import React from "react";

import styled from "styled-components/macro";

import { useMediaSettings } from "Signups/stateHooks";

import FnrButton from "UI/FnrButton3/FnrButton";
import FnrIcon from "UI/FnrIcon";

export const RemoveButtonWrapper = styled.div`
  opacity: 0;
  position: absolute;
  top: 64px;
  right: 6px;
  transition: opacity 200ms;
`;

export function RemoveMediaButton() {
  const { mediaSettings, setMediaType } = useMediaSettings();
  const mediaType = mediaSettings?.type;
  const hasMediaSetUp = mediaSettings?.videoUrl || mediaSettings?.imageUrl;

  const getButtonColor = () => {
    if (hasMediaSetUp) {
      return "red";
    }
    return "gray";
  };

  const getButtonContents = () => {
    if (hasMediaSetUp) {
      return (
        <>
          <FnrIcon far fa-trash-alt />
          &nbsp;Remove
        </>
      );
    }

    return (
      <>
        <FnrIcon far fa-times style={{ fontSize: 19 }} />
      </>
    );
  };

  const handleClick = () => {
    setMediaType("none");
  };

  if (!mediaType || mediaType === "none") return null;

  return (
    <FnrButton
      data-cy="Signup_RemoveMediaButton"
      size="small"
      color={getButtonColor()}
      onClick={handleClick}
      aria-label="remove image or video"
    >
      {getButtonContents()}
    </FnrButton>
  );
}